import { Grid } from '@material-ui/core';

// local imports
import { useInputChangeHandler } from 'app/hooks';
import RegionForm from './region-form';
import { AsyncButton, FormInput, MaskedInput } from '../../atoms';

const PharmacyCrudForm = ({ isEdit, loading }) => {
  const { values, preventNonSpecialCharsInput, preventOnlyNonSpecialCharsInput, handlePhoneInput } =
    useInputChangeHandler();
  const btnText = isEdit ? 'Eczaneyi Güncelle' : 'Eczane Ekle';
  const btnIcon = isEdit ? 'update' : 'add_business';

  return (
    <>
      <Grid container spacing={2}>
        {/* Pharmacy Info */}
        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <FormInput
            id="pharmacy_name"
            label="Eczane Adı"
            name="name"
            placeholder="Eczane Adı"
            disabled={loading}
            value={values?.name || ''}
            onChange={preventOnlyNonSpecialCharsInput}
            maxLength={50}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <MaskedInput
            disabled={loading}
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            id="id_telephone"
            name="telephone"
            placeholder="Eczane telefon no"
            label="Eczane Telefon No"
            value={values?.telephone || ''}
            onChange={handlePhoneInput}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <MaskedInput
            disabled={loading}
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            id="id_second_telephone"
            name="second_telephone"
            label="2. Telefon No"
            placeholder="2. telefon no"
            value={values?.second_telephone || ''}
            onChange={handlePhoneInput}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <FormInput
            id="pharmacy_email"
            label="E-Posta Adresi"
            name="email"
            placeholder="E-Posta Adresi"
            value={values?.email || ''}
            disabled={loading}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <FormInput
            id="attendant"
            label="Yetkili Ad-Soyad"
            name="attendant"
            placeholder="Yetkili ad-soyad"
            disabled={loading}
            value={values?.attendant || ''}
            onChange={preventNonSpecialCharsInput}
            maxLength={100}
          />
        </Grid>

        <Grid item xs={12} sm={6} lg={4} xl={3}>
          <MaskedInput
            disabled={loading}
            type="text"
            mask="+\90 \(999\) 999 99 99"
            maskChar="_"
            id="id_attendant_telephone"
            name="attendant_telephone"
            label="Yetkili Telefon No"
            placeholder="Yetkili telefon no"
            value={values?.attendant_telephone || ''}
            onChange={handlePhoneInput}
          />
        </Grid>

        <Grid item xs={12}>
          {/* City-District-Region Fields */}
          <RegionForm loading={loading} isEdit={isEdit} />
        </Grid>

        {/* Action buttons */}
        <Grid item xs={12} className="flex justify-end">
          <AsyncButton
            icon={btnIcon}
            text={btnText}
            loading={loading}
            className="bg-green-400 text-white hover:bg-green-600"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default PharmacyCrudForm;
